export default __webpack_public_path__ + "static/media/home-8.f8499047.jpg";